import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    BetslipFooterContainer,
    BalanceValue,
    ReturnsLabel,
    ReturnsWrapper,
    ReturnsValue,
} from './BetslipFooter.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Amount } from 'src_common/common/amount/Amount';
import { useCommon } from 'src/domains/common/Common';
import { SdkCustomer } from 'src/domains/layouts/state/customer';

export const BetslipFooter = observer('BetslipFooter', () => {
    const common = useCommon();
    const { betSlipState } = AppSportsBookState.get(common);
    const { session } = common;
    const { betSlipSummaryState } = betSlipState;
    const { potentialReturn, totalStake, balanceAfter, isLegsChangedWarning, isUnavailableSelectionsWarning, isAnyNA } =
        betSlipSummaryState;
    const zeroAmount = new Amount('0');
    const sdkCustomer = SdkCustomer.get(common);

    const { isAuthorized } = session;
    const notApplicable = 'n/a';
    const totalReturns = potentialReturn.isGreaterThan(zeroAmount)
        ? sdkCustomer.money(potentialReturn)
        : sdkCustomer.money(zeroAmount);
    const totalReturnsValue = isLegsChangedWarning || isUnavailableSelectionsWarning ? notApplicable : totalReturns;
    const balanceAfterValue = sdkCustomer.money(balanceAfter);

    return (
        <BetslipFooterContainer>
            <ReturnsWrapper data-test='total-returns'>
                <ReturnsLabel>
                    <I18n
                        langKey='betslip.total-returns-info'
                        defaultText='Total returns:'
                    />
                </ReturnsLabel>
                <ReturnsValue>{isAnyNA ? notApplicable : totalReturnsValue}</ReturnsValue>
            </ReturnsWrapper>

            {isAuthorized &&
            totalStake.isGreaterThan(zeroAmount) &&
            !isLegsChangedWarning &&
            !isUnavailableSelectionsWarning &&
            (balanceAfter.isGreaterThan(zeroAmount) || balanceAfter.isEqualWith(zeroAmount)) ? (
                <ReturnsWrapper data-test='balance-after'>
                    <ReturnsLabel>
                        <I18n
                            langKey='betslip.balance-value-info'
                            defaultText='Balance after:'
                        />
                    </ReturnsLabel>
                    <BalanceValue>{balanceAfterValue}</BalanceValue>
                </ReturnsWrapper>
            ) : null}
        </BetslipFooterContainer>
    );
});
